import withInput from './withInput';

const TextInput = withInput({
  classTypeModifier: 'textual-input',
});

export default TextInput;
